import request from '@/utils/request'

/**
 * 查询商品详情
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getProductDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品评价
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listShopAppraise(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise.listShopAppraise',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品标签
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listProductLabel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProductLabel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存购物车
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveStoreCart(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeCart.saveStoreCart',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取平台信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getPlatformInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.initPlatformData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}